var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.71468 14.6L5.42578 13.95",
    stroke: "#01234A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.41536 11.35L3.33203 8.82223",
    stroke: "#01234A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1.91 1.91"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.82405 7.52222L2.53516 6.87222",
    stroke: "#01234A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.30859 2.53889L7.95859 2.82778",
    stroke: "#01234A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1992 3.8389L12.5103 4.85001",
    stroke: "#01234A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1.71 1.71"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6641 5.35556L14.3141 5.64445",
    stroke: "#01234A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.25998 6.07778C4.85547 6.07778 6.14887 4.78438 6.14887 3.18889C6.14887 1.5934 4.85547 0.300002 3.25998 0.300002C1.66449 0.300002 0.371094 1.5934 0.371094 3.18889C0.371094 4.78438 1.66449 6.07778 3.25998 6.07778Z",
    fill: "#01234A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6271 16.1889V14.6722C23.6271 14.0944 23.1215 13.5889 22.5437 13.5889H21.966C21.5326 13.5889 21.1715 13.3722 20.9549 12.9389C20.8104 12.5056 20.8826 12.0722 21.1715 11.7833L21.6049 11.35C22.0382 10.9167 22.0382 10.2667 21.6049 9.83334L20.8104 9.03889C20.3771 8.60556 19.7271 8.60556 19.2937 9.03889L18.8604 9.47223C18.5715 9.76111 18.066 9.90556 17.7049 9.68889C17.2715 9.54445 17.0549 9.18334 17.0549 8.67778V8.1C17.0549 7.52223 16.5493 7.01667 15.9715 7.01667H15.8271H14.3826C13.8771 7.01667 13.3715 7.45 13.3715 8.02778V8.53334C13.3715 8.96667 13.1549 9.32778 12.7937 9.47223C12.4326 9.61667 11.9993 9.54445 11.7104 9.25556L11.3493 8.89445C10.9882 8.53334 10.3382 8.53334 9.97709 8.89445L9.18264 9.68889C8.82153 10.05 8.82153 10.7 9.18264 11.1333L9.54375 11.4944C9.83264 11.7833 9.90486 12.2167 9.76042 12.5778V13.0111C9.76042 13.0111 9.54375 13.6611 9.18264 13.5889H8.60487C8.09931 13.6611 7.59375 14.0944 7.59375 14.6722V16.1167C7.59375 16.6222 8.60487 17.2 8.60487 17.2H8.31597H8.89375C9.25486 17.2 9.6882 17.4167 9.83264 17.85V17.9222C9.97709 18.3556 9.90486 18.7889 9.61597 19.0778L9.18264 19.5111C8.82153 19.9444 8.82153 20.5944 9.18264 20.9556L9.97709 21.75C10.3382 22.1833 10.9882 22.1833 11.4215 21.75L11.7826 21.3167C12.0715 21.0278 12.5049 20.8833 12.866 21.1C13.2271 21.2444 13.516 21.6778 13.516 22.0389V22.6167C13.516 23.1944 13.9493 23.7 14.5271 23.7H16.0437C16.6215 23.7 17.1271 23.1944 17.1271 22.6167V22.1111C17.1271 21.6778 17.3438 21.3167 17.7771 21.1722C18.2104 21.0278 18.6437 21.1 18.9326 21.3889L19.366 21.8222C19.7993 22.2556 20.4493 22.2556 20.8826 21.8222L21.6771 21.0278C22.1104 20.5944 22.1104 19.9444 21.6771 19.5111L21.2438 19.0778C20.9549 18.7889 20.8104 18.2833 21.0271 17.9222C21.1715 17.4889 21.5326 17.2722 22.0382 17.2722H22.616C23.1215 17.2 23.6271 16.7667 23.6271 16.1889Z",
    fill: "white",
    stroke: "#01234A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6115 18.3556C17.207 18.3556 18.5004 17.0622 18.5004 15.4667C18.5004 13.8712 17.207 12.5778 15.6115 12.5778C14.0161 12.5778 12.7227 13.8712 12.7227 15.4667C12.7227 17.0622 14.0161 18.3556 15.6115 18.3556Z",
    fill: "#01234A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSize);
export default __webpack_public_path__ + "static/media/iconSize.16483fb85b1285ae1dc850c19ba90f95.svg";
export { ForwardRef as ReactComponent };